<template>
  <div class="page">
    <!-- your page -->
    <div class="footNav">
      <div class="fixation">
				<div class="ico_test">
					<div class="ico">
						<img src="../assets/article/you.png" alt="">
						<span>品质保障</span>
					</div>
					<div class="ico">
						<img src="../assets/article/7.png" alt="">
						<span>七天无理由退货</span>
					</div>
					<div class="ico">
						<img src="../assets/article/te.png" alt="">
						<span>特色服务体验</span>
					</div>
					<div class="ico">
						<img src="../assets/article/wenhao.png" alt="">
						<span>帮助中心</span>
					</div>
				</div>
        <div class="test">
          <div class="footNavLeft">
            <div class="unit" v-for="(item, index) in footNav" :key="index">
              <div class="unitMain">{{ item.main }}</div>
              <div
                class="unitLine"
                v-for="(tab, tabIndex) in item.tab"
                :key="tabIndex"
                @click="goArticle"
                :data-id="tab.id"
              >
                ·{{ tab.title }}
              </div>
            </div>
          </div>
					<div class="footNavRight">
							<div class="qrcode">
								<div class="qrcodeBox">
									{{tel}}
								</div>
								<div class="qrcodeWord">
									周一至周六 9:00-18:00
								</div>
							</div>
						</div>
        </div>
      </div>
    </div>
    <div class="copyright">
      <div class="about">
        <div class="aboutBox" :style="'width:' + 100 * about.length + 'px'">
          <div class="aboutUnit" v-for="item in about" :key="item.id" :data-id="item.id"  @click="goArticle">
            {{ item.title }}
          </div>
        </div>
      </div>
      <span class="align" v-if="address">经营地址：{{address}}</span>
      <span class="align" v-if="tel">联系方式：{{tel}}</span>
      <span class="align" style="cursor:pointer" @click="copyr">ICP备案号：{{copyright}}</span>
      <span class="align" style="cursor:police" v-if="police">公网安备：{{police}}</span>
      <span class="align" style="cursor:pointer" v-if="img" @click="openimg">营业执照<img @click="openimg" src="../assets/index/dz.png" style="height:14px;width：14px;" alt=""></span>
      
      <!-- <div class="address" v-if="address">
        <span>公司地址：{{address}}</span>
      </div>
      <div class="copyrightWord">
        <a href="https://beian.miit.gov.cn/" target="_blank">{{ copyright }}</a
        >&nbsp;&nbsp;<img src="../assets/index/police.png" v-if="police" alt="" />&nbsp;{{
          police
        }}
        <a href="./zhizhao.jpg" target="_blank"><img src="../assets/index/dz.png" style="height:21px;" alt=""></a>
      </div> -->
    </div>
  </div>
</template>

<script>
// your script
export default {
  name: "pubFoot",
  data() {
    return {
      footNav: [],
      qrcode: "",
      about: [],
      address:'sjz',
      copyright: "",
      police: "",
      shop_name: "",
			tel:'',
      img:''
    };
  },
  methods: {
    copyr(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    openimg(){
      window.open(this.img)
    },
    goArticle(e) {
      var id = e.target.dataset.id;
      this.$router.push({
        path: "/article",
        query: { aid: id, type: "article" },
      });
      this.$router.go(0);
    },
    fetchData() {
      var data = {
        method: "articles.getFooterAritic",
      };
      var that = this;
      this.request(data, (res) => {
        if (res.status) {
          var list = res.data[0];
          for (let i in list) {
            var obj = {
              main: list[i].type_name,
              tab: list[i].list,
            };
            that.footNav.push(obj);
          }
          that.about = res.data[1].list;
        } else {
          that.globalTest(
            "articles.getFooterAritic",
            "error",
            res.msg,
            res.data
          );
        }
      });
    },
    fetchCopyRight() {
      var data = {
        method: "config.config",
      };
      var that = this;
      this.request(data, function (res) {
        if (res.status) {
          that.copyright = res.data.copyrightWord;
          that.police = res.data.police;
          that.qrcode = res.data.qrcode;
          that.shop_name = res.data.shop_name;
					that.tel = res.data.tel
          that.img = res.data.img
          that.address = res.data.address
        } else {
          that.globalTest("config.config", "error", res.msg, res.data);
        }
      });
    },
  },
  beforeCreate: function () {
    //生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
  },
  created: function () {
    //生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
  },
  beforeMount: function () {
    //模板编译/挂载之前
  },
  mounted: function () {
    //模板编译/挂载之后
    this.fetchData();
    this.fetchCopyRight();
  },
  beforeUpdate: function () {
    //组件更新之前
  },
  updated: function () {
    //组件更新之后
  },
  activated: function () {
    // for keep-alive，组件被激活时调用
  },
  deactivated: function () {
    // for keep-alive，组件被移除时调用
  },
  beforeDestory: function () {
    // 组件销毁调用
  },
  destoryed: function () {
    // 组件销毁后调用
  },
};
</script>

<style scoped>
.address{
  display: flex;
  align-content: center;
  justify-content: center;
}
.page{
	background-color: white;
	margin-top: 50px;
}
/* your css */
.footNav {
  width: 100%;
  /* height: 220px; */
}
.ico_test{
	display: flex;
	justify-content: space-between;
	padding: 0 50px;
	padding-top: 25px;
}
.ico{
	display: flex;
	align-content: center;
}
.ico span{
	font-size: 20px;
	line-height: 40px;
	margin-left: 5px;
}
.test {
  width: 100%;
	display: flex;
	justify-content: space-between;
}
.footNavLeft {
  height: 160px;
  /* float: left; */
  margin-top: 50px;
  text-align: center;
}
.unit {
  width: 180px;
  height: 100%;
  float: left;
  padding-top: 30px;
}
.unitMain {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-size: 18px;
}
.unitLine {
  width: 100%;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  color: #838383;
  cursor: pointer;
}
.unitLine:hover {
  color: #036dee;
}
.footNavRight {
  width: 360px;
  height: 160px;
  margin-top: 50px;
  border-left: 1px solid #b3b3b3;
  box-sizing: border-box;
}
.qrcode {
  width: 100%;
  height: 100%;
	padding-top: 30px;
}
.qrcodeBox {
  height: 60px;
	line-height: 60px;
	color: #036dee;
	font-size: 30px;
	text-align: center;
}
.qrcode img {
  width: 100%;
  height: 100%;
  display: block;
}
.qrcodeWord {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
	color: #838383;
}
.copyright {
  width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px auto;
  height: auto;
}
.align{
  font-size: 14px;
  display: block;
  padding-top: 10px;
  color: #9b9b9b;
}
.align:hover{
  color: #007df6!important;
}
.about {
  width: 100%;
  height: 40px;
  padding-top: 13px;
  box-sizing: border-box;
}
.aboutBox {
  height: 24px;
  margin: 0 auto;
  line-height: 24px;
  font-size: 0px;
  letter-spacing: -6px;
  color: #838383;
}
.aboutUnit {
  width: 100px;
  height: 100%;
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  letter-spacing: normal;
  border-right: 1px solid #b3b3b3;
  text-align: center;
  box-sizing: border-box;
  cursor: pointer;
}
.aboutUnit:hover {
  color: #036dee;
}
.aboutUnit:last-child {
  border: none;
}
.copyrightWord {
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
  text-align: center;
}
.copyrightWord img{
  width:20px;
  height: 20px;
}
.copyrightWord a {
  color: #000000;
}
.copyrightWord a:hover {
  color: #036dee;
}
</style>
